var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-dialog',{attrs:{"title":"본인인증","persistent":"","max-width":"460px","width":"460px"},model:{value:(_vm.perCertDialog),callback:function ($$v) {_vm.perCertDialog=$$v},expression:"perCertDialog"}},[_c('div',{attrs:{"id":"wrap"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }